import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

function useRemoveTrailingSlash() {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (history && location?.pathname?.match('/.*/$')) {
      history.replace({
        ...location,
        pathname: location.pathname.replace(/\/+$/, ''),
      });
    }
  }, [location]);
}

export default useRemoveTrailingSlash;
